<template>
  <Wrapper
    v-show="
      !preview && renderTools && isShowWrapper &&
      !['reheight_widget', 'remargin_widget', 'sort_widget', 'reheight_grid', 'remargin_grid', 'reheight_component'].includes(mode)
    "
    id="cell-hover-frame"
    class="cell-hover cursor-pointer"
    :class="{'top': !isOverScroll, 'bottom': isOverScroll}"
    :position="cellHover.position"
    @click="click"
  >
    <div>
      <Legend class="lbl-name" :indexCell="indexCell" v-if="isOverlap && sectionActive.id === section_id && indexCell == 0" style="color: #12A9FF; left: 126px;">
        {{ $t('engine.floatframeTool.floatframeHover.cell.lblCell', languageEngine) }}
      </Legend>
      <Legend class="lbl-name" :indexCell="indexCell" v-else style="color: #12A9FF;">
        {{ $t('engine.floatframeTool.floatframeHover.cell.lblCell', languageEngine) }}
      </Legend>
    </div>
  </Wrapper>
</template>

<script>
import { mapGetters } from "vuex";
import { Wrapper, Legend } from "./CellHover.styled";
import { SECTION, WIDGET } from "@model/components/componentMeta.model";
import { findParentComponent } from "@helpers/component.helper";

export default {
  components: {
    Wrapper,
    Legend,
  },
  data() {
    return {
      positionTool: "top",
      topElementPosition: 0,
    }
  },
  watch: {
    scrollPosition() {
      this.$store.dispatch("designIframe/component/setComponentAction", {
        component_id: this.cellHover.id,
        type: "CELL",
        action: "HOVER",
      });
    },
    mode() {
      this.$nextTick(function () {
        this.$store.dispatch("designIframe/component/setComponentAction", {
          component_id: this.cellHover.id,
          type: "CELL",
          action: "HOVER",
        });
      });
    },
    cellHover: {
      deep: true,
      handler() {
        const element = document.getElementById("cell-hover-frame")
        if(element) {
          this.$nextTick(() => {
            this.topElementPosition = element.offsetTop;
          })
        }
      }
    }
  },
  computed: {
    ...mapGetters({
      preview: "designIframe/preview",
      renderTools: "designIframe/frame/renderTools",
      widgetHover: "designIframe/frame/widgetHover",
      sectionActive: "designIframe/frame/sectionActive",
      cellHover: "designIframe/frame/cellHover",
      cellActive: "designIframe/frame/cellActive",
      widgetActive: "designIframe/frame/widgetActive",
      gridHover: "designIframe/frame/gridHover",
      mode: "designIframe/mode",
      scrollPosition: "scrollPosition",
      components: "designIframe/metadata/components",
      detectDevice: "detectDevice",
      languageEngine: "designIframe/userPreference/languageEngine"
    }),
    isOverScroll() {
      this.scrollPosition;
      const diff = this.scrollPosition - this.topElementPosition;
      if (diff >= 0) {
        return true;
      } else {
        return false;
      }
    },
    grid_id() {
      if (this.cellHover.id) {
        return Object.keys(this.components).find((key) =>
          this.components[key].componentsID && this.components[key].componentsID.includes(this.cellHover.id)
        );
      } else {
        return null;
      }
    },
    indexCell() {
      if (this.grid_id) {
        if (this.detectDevice == 'mobile') {
          return this.components[this.grid_id].componentsIDMobile.indexOf(this.cellHover.id);
        } else {
          return this.components[this.grid_id].componentsID.indexOf(this.cellHover.id);
        }
      } else {
        return 0;
      }
    },
    sectionName() {
      return SECTION.name
    },
    widgetName() {
      return WIDGET.name
    },
    parentId() { // section or widget
      return this.grid_id && Object.keys(this.components).find((key) =>
        this.components[key].componentsID && this.components[key].componentsID.includes(this.grid_id)
      );
    },
    parentComponent() { // section or widget
      return this.parentId && this.components[this.parentId]
    },
    parentName() {
      if (this.parentId) {
        if (this.parentId.substring(0, SECTION.prefixKey.length) == SECTION.prefixKey) {
          return this.sectionName
        } else if (this.parentId.substring(0, WIDGET.prefixKey.length) == WIDGET.prefixKey) {
          return this.widgetName
        }
      }
      return null;
    },
    parentFocusId() {
      if (this.parentId) {
        if (this.parentComponent.type == 'SECTION_WIDGET_TAB_ITEM') {
          return Object.keys(this.components).find((key) =>
            this.components[key].componentsID && this.components[key].componentsID.includes(this.parentId)
          );
        } else {
          return this.parentId
        }
      }
      return null;
    },
    section_id() {
      return this.grid_id && Object.keys(this.components).find((key) =>
        this.components[key].componentsID && this.components[key].componentsID.includes(this.grid_id)
      );
    },
    sectionComponent() {
      return this.section_id && this.components[this.section_id]
    },
    gridMarginTop() {
      return (
        this.components[this.grid_id] &&
        this.components[this.grid_id].style.marginTop
      );
    },
    indexGrid() {
      return this.parentComponent.componentsID.indexOf(this.grid_id);
    },
    isFirstIndex() {
      return this.indexGrid == 0;
    },
    isOverlap() {
      return this.parentComponent && this.parentComponent.style.width == 'container-fluid' && this.isFirstIndex && this.gridMarginTop == 0
    },
    isParentWidget() {
      if (this.widgetActive.id) {
        const parentWidgetIds = findParentComponent(this.components, this.widgetActive.id);
        return parentWidgetIds.indexOf(this.cellHover.id) !== -1;
      }
      return false;
    },
    isShowWrapper() {
      return  this.cellHover.id && (this.cellHover.id != this.cellActive.id || this.isParentWidget)
    }
  },
  methods: {
    click() {
      if (this.cellHover.id && this.grid_id) {
        this.$store.dispatch("designIframe/frame/setParentWidgetActive", {});
        this.$store.dispatch("designIframe/frame/setWidgetActive", {})
        this.$store.dispatch("designIframe/frame/setWidgetHover", {})
        this.$store.dispatch("designIframe/component/elActive", {
          elementID: ["component", this.cellHover.id],
        });

        if (this.parentName == this.widgetName) {
          this.$store.dispatch("designIframe/frame/setCellActive", {
            component_id: this.cellHover.id,
            parent_id: this.grid_id,
            widget_key: this.parentFocusId,
          });
        } else {
          this.$store.dispatch("designIframe/frame/setCellActive", {
            component_id: this.cellHover.id,
            parent_id: this.grid_id,
          });
        }
      }

      this.$store.dispatch("designIframe/frame/setSlideContainerHover", {})
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {})
      this.$store.dispatch("designIframe/frame/setFloatFrameActive", {});
      this.$store.dispatch("designIframe/frame/setFloatFrameHover", {});
      this.$store.dispatch("designIframe/frame/setSectionHover", {});
      this.$store.dispatch("designIframe/frame/setSlideSectionActive", {});
      this.$store.dispatch("designIframe/frame/setSlideContainerActive", {});

      if (this.parentName == this.widgetName) {
        this.$store.dispatch("designIframe/frame/setSectionActive", {});
      } else {
        this.$store.dispatch("designIframe/frame/setSectionActive", {
          component_id: this.parentFocusId,
          name: this.parentFocusId,
        });
      }
    },
  },
};
</script>

<style lang="scss">
</style>